import React from "react";


const timeoutContext = React.createContext();

export default timeoutContext;